<template>
  <div>
    <div class="DataTable">
      <div class="vld-parent">
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
          color="#018389"
          loader="dots"
        ></loading>
      </div>
      <v-form ref="form1" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 pa-2>
            <span v-if="this.kolicinaVina > 0"
              >Faza {{ this.faza_mark }} / Količina {{ this.kolicinaVina }}
              {{ this.jm_mark }}</span
            >
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs5 pa-2>
            <v-autocomplete
              ref="element1"
              v-model="tank_to_select"
              :items="tank_to_items"
              item-value="id"
              item-text="name"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              label="Tank u koji se filtrira"
              required
              persistent-hint
              return-object
              v-on:change="changeRoute"
              :disabled="!edit"
            >
              <template slot="selection" slot-scope="data">
                <template v-if="data.item.phaseMark === null"
                  >{{ data.item.name }} / (prazan tank) / Zapremina
                  {{ data.item.capacity }}
                  {{ data.item.unitOfMeasureMark }}</template
                >
                <template v-else-if="data.item.id === 0"
                  >Izaberite tank</template
                >
                <template v-else-if="!edit"
                  >{{ data.item.name }} / {{ data.item.phaseMark }}</template
                >
                <template v-else
                  >{{ data.item.name }} / {{ data.item.phaseMark }} / Slobodno
                  {{ data.item.capacity - data.item.currentQuantity }}
                  {{ data.item.unitOfMeasureMark }}</template
                >
              </template>
              <template slot="item" slot-scope="data">
                <template v-if="data.item.phaseMark === null"
                  >{{ data.item.name }} / (prazan tank) / Zapremina
                  {{ data.item.capacity }}
                  {{ data.item.unitOfMeasureMark }}</template
                >
                <template v-else-if="data.item.id === 0"
                  >Izaberite tank</template
                >
                <template v-else-if="!edit"
                  >{{ data.item.name }} / {{ data.item.phaseMark }}</template
                >
                <template v-else
                  >{{ data.item.name }} / {{ data.item.phaseMark }} / Slobodno
                  {{ data.item.capacity - data.item.currentQuantity }}
                  {{ data.item.unitOfMeasureMark }}</template
                >
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
              :disabled="!edit"
            >
              <v-text-field
                slot="activator"
                v-model="dateFormatted"
                label="Datum"
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
                @blur="date = parseDate(dateFormatted)"
                :disabled="!edit"
              ></v-text-field>
              <v-date-picker
                v-model="date"
                no-title
                @input="menu = false"
                :max="maxDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-menu
              ref="menu1"
              :close-on-content-click="false"
              v-model="menu1"
              :nudge-right="0"
              :return-value.sync="time"
              transition="scale-transition"
              lazy
              offset-y
              full-width
              min-width="290px"
              @input="
                (value) =>
                  value && $refs.picker && ($refs.picker.selectingHour = true)
              "
              :disabled="!edit"
            >
              <v-text-field
                slot="activator"
                v-model="time"
                label="Vreme"
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
                :disabled="!edit"
              ></v-text-field>
              <v-time-picker
                v-model="time"
                ref="picker"
                full-width
                landscape
                class="mt-3"
                format="24hr"
                :allowed-minutes="allowedStep"
                v-on:change="$refs.menu1.save(time)"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu1 = false"
                  >Cancel</v-btn
                >
                <!-- <v-btn flat color="primary" @click="$refs.menu1.save(time)">OK</v-btn> -->
              </v-time-picker>
            </v-menu>
          </v-flex>

          <v-flex xs3 pa-2>
            <!-- <v-select
                v-model="aditiv_select"
                :items="aditiv_items"
                item-text="name"
                item-value="id"
                :rules="[v => !!v || 'Obavezan podatak']"
                label="Dodatak"
                required
                return-object
            ></v-select>-->

            <!-- <v-btn @click.stop="dialogNote = true" class="AppButtonFilled">Repromaterijal</v-btn> -->
            <v-btn @click.stop="otvoriModal" class="AppButtonFilled"
              >Repromaterijal</v-btn
            >
          </v-flex>
        </v-layout>
        <!-- /.Name -->
      </v-form>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout v-if="tank_type === 'batch'">
          <v-flex xs12 pa-2>
            <v-autocomplete
              ref="elementsarza"
              v-model="sarza_select"
              :items="sarza_items"
              :item-text="getFieldText"
              item-value="tank.id"
              label="Barik"
              multiple
              chips
              deletable-chips
              hide-no-data
              clearable
              persistent-hint
              return-object
              
              :disabled="!edit"
            ></v-autocomplete>
          </v-flex>
          <!-- v-on:change="changeSarza" -->
        </v-layout>
        <v-layout row wrap>
          <v-flex xs2 pa-2>
            <v-text-field
              v-model="filtering_quantity"
              label="Količina"
              type="number"
              min="0"
              required
              :disabled="!edit"
            ></v-text-field>
          </v-flex>

          <v-flex xs2 pa-2>
            <v-select
              v-model="jm_dolivanja_select"
              :items="jm_items"
              item-text="mark"
              item-value="id"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              label="JM"
              required
              persistent-hint
              return-object
              :disabled="!edit"
            ></v-select>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-text-field
              v-model="sediment_quantity"
              :label="tekst_labele_1"
              type="number"
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-select
              v-model="jm_sediment_select"
              :items="jm_sediment_items"
              item-text="mark"
              item-value="id"
              label="JM"
              persistent-hint
              return-object
              :disabled="!edit"
            ></v-select>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-text-field
              v-model="outage_quantity"
              label="Rastur"
              type="number"
              :disabled="!edit"
            ></v-text-field>
          </v-flex>

          <v-flex xs2 pa-2>
            <v-select
              v-model="jm_outage_select"
              :items="jm_outage_items"
              item-text="mark"
              item-value="id"
              label="JM"
              persistent-hint
              return-object
              :disabled="!edit"
            ></v-select>
          </v-flex>
        </v-layout>
        <!-- /.Name -->

        <v-layout row wrap>
          <v-flex xs12 pa-2>
            <v-textarea
              v-model="opis"
              name="input-5-1"
              class="Description"
              label="Opis"
            ></v-textarea>
          </v-flex>
        </v-layout>
        <!-- /.Tank -->

        <v-layout row wrap>
          <v-flex xs12>
            <v-btn
              :disabled="!valid"
              @click="submit"
              class="AppButtonFilled"
              >Sačuvaj</v-btn
            >
            <v-btn
              @click="clear"
              class="AppButtonOutlined"
              >odustani</v-btn
            >
          </v-flex>
        </v-layout>
        <!-- /.Action buttons -->
      </v-form>
    </div>

    <!-- MODAL -->
    <v-dialog v-model="dialogNote" scrollable content-class="ModalInModal">
      <v-container>
        <div class="DataTable">
          <div
            data-v-fae5bece
            class="v-card__title headline lighten-2 v-card__title--primary"
            style="
              padding-left: 10px;
              padding-bottom: 0px;
              padding-top: 0px;
              padding-right: 0px;
              font-size: 18px !important;
            "
          >
            <!-- Modal Titles  -->

            <div>Repromaterijal</div>

            <button
              id="closeModalInModalBtn"
              @click.prevent="closeModalInModal"
              class="v-btn v-btn--flat white"
            >
              <v-icon>close</v-icon>
            </button>
          </div>

          <div data-v-fae5bece class="spacer"></div>
          <v-form ref="form_modal" v-model="valid1" lazy-validation>
            <v-layout row wrap>
              <v-flex xs3 pa-2>
                <v-select
                  v-model="additiv_group_to_select"
                  :items="additiv_group_to_items"
                  item-text="name"
                  item-value="id"
                  label="Grupa aditiva"
                  persistent-hint
                  return-object
                  :rules="[(v) => !!v || 'Obavezan podatak']"
                  required
                  v-on:change="changeAditiveGroup"
                  :disabled="izmena_aditiva || !edit"
                ></v-select>
              </v-flex>
              <v-flex xs5 pa-2>
                <v-autocomplete
                  v-model="aditiv_select"
                  :items="aditiv_items"
                  item-text="name"
                  item-value="id"
                  :rules="[(v) => !!v || 'Obavezan podatak']"
                  label="Dodatak"
                  required
                  persistent-hint
                  return-object
                  v-on:change="getAllJediniceMereAditiv"
                  :disabled="izmena_aditiva || !edit"
                ></v-autocomplete>
              </v-flex>
              <v-flex
                xs1
                pa-2
                style="
                  padding-top: 20px !important;
                  padding-left: 0px !important;
                  padding-top: 20px !important;
                "
                v-if="1===2"
              >
                <v-icon
                  slot="activator"
                  @click="otvoriSifarnik"
                  style="color: #018389; padding-left: 0px; font-weight: bold"
                  title="Dodavanje repromaterijala"
                  v-if="
                    !izmena_aditiva &&
                    edit &&
                    additiv_group_to_select !== undefined
                  "
                  >add</v-icon
                >
              </v-flex>
              <v-flex xs2 pa-2 style="width: 55% !important">
                <v-text-field
                  v-model="kolicina_modal"
                  label="Količina"
                  type="number"
                  min="0"
                  :rules="[(v) => !!v || 'Obavezan podatak']"
                  required
                  :disabled="izmena_aditiva || !edit"
                ></v-text-field>
              </v-flex>
              <v-flex xs1 pa-2>
                <v-select
                  v-model="jm_select"
                  :items="jm_items_dodatak"
                  :item-text="getFieldTextJM"
                  item-value="id"
                  :rules="[(v) => !!v || 'Obavezan podatak']"
                  label="JM"
                  required
                  persistent-hint
                  return-object
                  :disabled="!edit"
                ></v-select>
              </v-flex>
              <v-flex xs1 style="padding-left: 0px">
                <v-icon
                  slot="activator"
                  id="FloatingButton"
                  @click="submit_parameter"
                  title="Spisak izdatnica"
                  v-if="edit"
                  >add</v-icon
                >
              </v-flex>
            </v-layout>
            <!-- /.Datepicker -->

            <v-layout row wrap>
              <v-flex xs12 pa-2>
                <v-textarea
                  v-model="opis_modal"
                  name="input-5-1"
                  class="Description"
                  label="Opis"
                  :disabled="!edit"
                ></v-textarea>
              </v-flex>
              <!-- /.Dodatak Input -->
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12>
                <v-btn
                  :disabled="!valid1 || !edit"
                  @click="submit_modal"
                  class="AppButtonFilled"
                  >Sačuvaj</v-btn
                >

                <v-btn
                  @click="clear_modal_init"
                  class="AppButtonOutlined"
                  :disabled="!edit"
                  v-if="edit"
                  >odustani</v-btn
                >
                <v-btn
                  @click="clear_modal_init"
                  class="AppButtonOutlined"
                  :disabled="!edit"
                  v-else
                  style="border: none !important"
                  >odustani</v-btn
                >
              </v-flex>
            </v-layout>
            <!-- /.Action buttons -->
            <v-layout column>
              <v-flex style="overflow: auto">
                <v-data-table
                  :headers="headers_modal"
                  :items="items_modal"
                  hide-actions
                  class="elevation-1"
                >
                  <template slot="items" slot-scope="props_modal">
                    <td v-if="props_modal.item.additiv !== null">
                      {{ props_modal.item.additiv.name }}
                    </td>
                    <td v-else>{{ "" }}</td>

                    <td>{{ props_modal.item.quantity }}</td>

                    <td>{{ props_modal.item.unitOfMeasure.name }}</td>

                    <td style="display: none">
                      {{ props_modal.item.unitOfMeasure }}
                    </td>
                    <td style="display: none">
                      {{ props_modal.item.additiv }}
                    </td>

                    <td>{{ props_modal.item.description }}</td>
                    <td class="DataTable__ButtonHolder">
                      <img
                        class="DataTable__Button"
                        title="Izmena"
                        src="../assets/icons/zatabele/ico-edit2.svg"
                        alt="ulaz-grozdja"
                        @click="editItemModal(props_modal.item)"
                        v-if="edit"
                      />
                      <img
                        class="DataTable__Button"
                        title="Pregled"
                        src="../assets/icons/zatabele/ico-view.png"
                        alt="ulaz-grozdja"
                        @click="editItemModal(props_modal.item)"
                        v-else
                      />
                      <img
                        class="DataTable__Button"
                        title="Pregled izdantnica"
                        src="../assets/icons/zatabele/ico-add.svg"
                        alt="delete-item"
                        @click="otvoriDialogIzdtnica(props_modal.item)"
                      />
                      <img
                        class="DataTable__Button"
                        title="Brisanje"
                        src="../assets/icons/zatabele/ico-delete2.svg"
                        alt="delete-item"
                        @click="deleteItemModal(props_modal.item)"
                        v-if="edit"
                      />
                    </td>
                  </template>
                  <template slot="no-data">
                    <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                    <v-alert
                      slot="no-results"
                      :value="true"
                      color="primary"
                      icon="info"
                      >Nema podataka.</v-alert
                    >
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-form>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNoteIzdatnice"
      scrollable
      content-class="ModalInModal"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div v-if="this.jm_select !== undefined">
                Izdatnice za izbor - {{ this.selectedArticleName }}
                {{ parseFloat(this.additiveQuantity).toFixed(this.brojDec) }}
                {{ this.jm === "psc" ? "kom" : this.jm }}
              </div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModal"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>

            <MyComponent
              @newdata="handleData($event)"
              @change="handleDataChange($event)"
              @close="handleDataClose($event)"
              :articleId="selectedArticle"
              :documentId="materialOperationId"
              operation="FILTERING_ADDITIVE"
              :unitOfMeasureId="jm_select"
              :additiveQuantity="additiveQuantity"
              :ID="ID"
              :izabrani_aditiv="izabrani_aditivi"
              :edit="edit"
            ></MyComponent>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_operacije"
      scrollable
      content-class="ModalInModalGrafic"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <AdditiveComponent
              @close="handleDataCloseOperacije($event)"
              :operationType="operacija"
            ></AdditiveComponent>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";
import MyComponent from "./AddingNewComponent";

import AdditiveComponent from "../views/AdditiveItemComponentPom.vue";

export default {
  name: "FilteringItem",
  components: {
    TokenComponent,
    MyComponent,

    AdditiveComponent,
    Loading,
  },
  data: () => ({
    isLoading: false,
    loading: true,
    fullPage: true,

    valid: true,
    valid1: true,
    // valid_modal: true,
    ID: "0",
    ID_aditiv: 0,
    opis: "",
    vineyard_grape_variety_items: [],
    jm_dolivanja_select: "",
    jm_outage_select: "",
    vineyard_grape_variety_select: "",
    date: null, //For datepicker
    menu: "",
    entry_date: null, //For datepicker
    entry_menu: "",
    filtering_quantity: undefined,
    jm_items: [],
    jm_items_dodatak: [],
    outage_quantity: undefined,
    jm_outage_items: [],
    id_tank_phase_wine: 0,
    id_tank: 0,
    id_tank_phase_wine_blend: 0,
    aditiv_items: [],
    aditiv_select: "",
    additiv_group_to_items: [],
    additiv_group_to_select: undefined,
    dialogNote: false,
    items_modal: [],
    headers_modal: [
      { text: "Dodatak", value: "dodatak" },
      { text: "Količina", value: "kolicina" },
      { text: "JM", value: "width" },
      { text: "Opis", value: "opis" },
      { text: "Funkcije", value: "funkcije", sortable: false },
    ],
    kolicina_modal: undefined,
    jm_select: "",
    opis_modal: "",
    index_izmene: -1,
    isEmptyTank: false,
    isEmptyTank: false,
    tip_vina_tank: 0,
    sediment_quantity: undefined,
    jm_sediment_items: [],
    jm_sediment_select: "",
    time: "",
    menu1: "",
    tank_to_select_name_stara: "",
    tank_to_select_name_nova: "",
    preostalo_izabrani_tank: 0,
    preostalo_izabrani_tank_jm: "",
    tank_to_select: undefined,
    tank_id: 0,
    tank_to_items: [],
    kolicinaVina: 0,
    kolicinaVinaPom: 0,
    faza_mark: "",
    jm_mark: "",
    load: 0,
    tank_to_items_init: [],

    date: null,
    dateFormatted: null,
    tekst_labele_1: "",
    edit: true,

    materialFromWarehouseDocumentItemList: [],
    additiveQuantity: 0,
    jm: "",
    dialogNoteIzdatnice: false,
    selectedArticle: 0,
    selectedArticleName: "",
    materialOperationId: 0,
    brojDec: 0,
    tank_type: "",
    sarza: false,
    sarza_items: [],
    sarza_select: [],
    izabrani_barici: [],
    kolicina_vina_barici: 0,
    applied: false,
    izmena_aditiva: false,
    izabrani_aditivi: [],
    operacija: undefined,
    dialogNote_operacije: false,
  }),
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  methods: {
    handleDataCloseOperacije: function (e) {
      // this.getAllOperations(e.name);
      this.getAditives(this.additiv_group_to_select.id, e.name);
      this.dialogNote_operacije = false;
    },
    getAllSarze(id_sarze, item) {
      let url;

      if (this.id_tank_phase_wine !== 0)
        url =
          this.globalServiceLocation +
          this.globalPort +
          "/tank/tanks_in_batch/" +
          id_sarze +
          "/modal?tpwId=" +
          this.id_tank_phase_wine;
      else
        url =
          this.globalServiceLocation +
          this.globalPort +
          "/tank/tanks_in_batch/" +
          id_sarze +
          "/modal";

      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // console.log(response.data);
          this.sarza_items = response.data;

          let objPom = [];

          if (this.ID !== 0 && item !== null) {
            item.tankFromBatchInOperations.forEach(function (entry) {
              objPom.push(entry);
            });

            this.sarza_select = objPom;
            this.izabrani_barici = objPom;
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      this.sarza_items = response.data;

                      let objPom = [];

                      if (this.ID !== 0 && item !== null) {
                        item.tankFromBatchInOperations.forEach(function (
                          entry
                        ) {
                          objPom.push(entry);
                        });

                        this.sarza_select = objPom;
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    obrisi_izabrane_aditive(item, ind) {
      let index;

      if (this.izabrani_aditivi.length === 0) {
        this.items_modal.splice(ind, ind + 1);
      } else {
        if (item.materialFromWarehouseDocumentItemList !== undefined) {
          if (item.materialFromWarehouseDocumentItemList.length > 0)
            index = this.izabrani_aditivi.findIndex(
              (x) =>
                x.additiv.id === item.additiv.id &&
                x.materialFromWarehouseDocumentItemList[0]
                  .materialOperationId ===
                  item.materialFromWarehouseDocumentItemList[0]
                    .materialOperationId &&
                x.materialFromWarehouseDocumentItemList[0]
                  .warehouseInputOutputItem.id ===
                  item.materialFromWarehouseDocumentItemList[0]
                    .warehouseInputOutputItem.id
            );
        } else if (item.materialFromWarehouseDocumentItems.length > 0)
          index = this.izabrani_aditivi.findIndex(
            (x) =>
              x.additiv.id === item.additiv.id &&
              x.materialFromWarehouseDocumentItems[0].materialOperationId ===
                item.materialFromWarehouseDocumentItems[0]
                  .materialOperationId &&
              x.materialFromWarehouseDocumentItems[0].warehouseInputOutputItem
                .id ===
                item.materialFromWarehouseDocumentItems[0]
                  .warehouseInputOutputItem.id
          );

        if (index !== -1) this.izabrani_aditivi.splice(index, index + 1);
      }
    },
    popuni_izabrane_aditive(niz) {
      this.izabrani_aditivi = [];

      let index;
      let _this = this;

      if (niz !== undefined)
        niz.forEach(function (element) {
          // index = _this.izabrani_aditivi.indexOf(element);
          if (element.materialFromWarehouseDocumentItems !== undefined) {
            if (element.materialFromWarehouseDocumentItems.length > 0)
              index = _this.izabrani_aditivi.findIndex(
                (x) =>
                  x.additiv.id === element.additiv.id &&
                  x.materialFromWarehouseDocumentItemList[0]
                    .materialOperationId ===
                    element.materialFromWarehouseDocumentItems[0]
                      .materialOperationId &&
                  x.materialFromWarehouseDocumentItemList[0]
                    .warehouseInputOutputItem.id ===
                    element.materialFromWarehouseDocumentItems[0]
                      .warehouseInputOutputItem.id
              );
          } else if (element.materialFromWarehouseDocumentItems.length > 0) {
            index = _this.izabrani_aditivi.findIndex(
              (x) =>
                x.additiv.id === element.additiv.id &&
                x.materialFromWarehouseDocumentItems[0].materialOperationId ===
                  element.materialFromWarehouseDocumentItems[0]
                    .materialOperationId &&
                x.materialFromWarehouseDocumentItems[0].warehouseInputOutputItem
                  .id ===
                  element.materialFromWarehouseDocumentItems[0]
                    .warehouseInputOutputItem.id
            );
          }

          if (index !== -1) _this.izabrani_aditivi.splice(index, index + 1);
          _this.izabrani_aditivi.push(element);
        });
    },
    getFieldText(item) {
      let tekst = "";

      if (item.id !== undefined) {
        if (
          item.batchPrefix !== null &&
          item.tankNumberInBatch !== null &&
          item.batchPrefix !== "" &&
          item.tankNumberInBatch !== ""
        )
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.batchPrefix} - ${item.tankNumberInBatch} | ${item.tank.name} | ${item.tank.inventoryNumber}`;
          else
            tekst = `${item.batchPrefix} - ${item.tankNumberInBatch} | ${item.tank.name})`;
        else if (
          (item.batchPrefix === null || item.batchPrefix === "") &&
          (item.tankNumberInBatch === null || item.tankNumberInBatch === "")
        )
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.tank.name} | ${item.tank.inventoryNumber}`;
          else tekst = `${item.tank.name}`;
        else if (
          item.tankNumberInBatch === null ||
          item.tankNumberInBatch === ""
        )
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.batchPrefix} | ${item.tank.name} | ${item.tank.inventoryNumber}`;
          else tekst = `${item.batchPrefix} (${item.tank.name})`;
        else if (item.batchPrefix === null || item.batchPrefix === "")
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.tankNumberInBatch} | ${item.tank.name} | ${item.tank.inventoryNumber}`;
          else tekst = `${item.tankNumberInBatch} | ${item.tank.name}`;
      }

      return tekst;
    },
    submit_parameter(e) {
      if (this.ID > 0 && this.ID_aditiv === 0)
        alert("Pre izbora materijala sa izdatnica, morate snimiti dodatak.");
      else if (
        this.additiv_group_to_select === undefined ||
        this.additiv_group_to_select === ""
      )
        alert("Grupa repromaterijala mora biti unešena.");
      else if (this.aditiv_select === undefined || this.aditiv_select === "")
        alert("Repromaterijal mora biti unešen.");
      else if (this.kolicina_modal > 0 && this.jm_select !== undefined) {
        e.preventDefault();
        // this.materialFromWarehouseDocumentItemList = [];
        this.dialogNoteIzdatnice = true;

        this.additiveQuantity = this.kolicina_modal;

        if (this.jm_select.mark !== undefined) {
          let pomStr = this.jm_select.mark;
          this.jm = pomStr.split("/")[0];
        }

        if (this.jm === "psc") this.brojDec = 0;
        else this.brojDec = 2;
      } else alert("Količina i jedinica mere moraju biti unete.");
    },
    handleData: function (e) {
      this.materialFromWarehouseDocumentItemList = e;
      this.dialogNoteIzdatnice = false;

      this.getAllSifarnik();

      if (this.ID !== 0) this.clear_modal();
    },
    handleDataChange: function (e) {
      this.izmena_aditiva = e;
    },
    handleDataClose: function (e) {
      this.materialFromWarehouseDocumentItemList = e;
      this.dialogNoteIzdatnice = false;

      if (this.materialFromWarehouseDocumentItemList.length === 0)
        alert("Nisu izabrane količine sa izdatnica.");
    },
    closeModal() {
      this.dialogNoteIzdatnice = false;

      if (this.materialFromWarehouseDocumentItemList.length === 0)
        alert("Nisu izabrane količine sa izdatnica.");
    },
    otvoriDialogIzdtnica(item) {
      this.editItemModal(item);

      this.dialogNoteIzdatnice = true;
    },

    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedStep: (m) => m % 5 === 0,
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    getFieldTextJM(item) {
      let tekst = item.mark;

      if (item.mark === "psc") tekst = "kom";

      return tekst;
    },
    getAllSifarnik() {
      // // console.log(this.ID);

      if (this.ID !== undefined && this.ID !== 0) {
        // // console.log(this.ID);

        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/filtering/additiv/" +
              this.ID,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            this.items_modal = response.data;

            //// // console.log(this.items);
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/filtering/additiv/" +
                          this.ID,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.items_modal = response.data;

                        //// // console.log(this.items);
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    otvoriSifarnik(event) {
      this.operacija = "Filtriranje|" + this.additiv_group_to_select.id;
      this.dialogNote_operacije = true;
    },
    getAllTankovi(svi) {
      let tipVinaPom = 0;

      if (svi === false) tipVinaPom = this.tipVina;

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/filtering/" +
            this.id_tank +
            "/" +
            tipVinaPom +
            "/" +
            this.faza,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          // this.tank_to_items = response.data;

          this.tank_to_items_init = response.data;
          this.tank_to_items_init.splice(0, 0, {
            id: 0,
            name: undefined,
            phaseMark: undefined,
          });

          // // console.log(this.tank_to_items_init);

          this.tank_to_items = this.tank_to_items_init;

          if (this.tank_id !== 0) this.tank_to_select = this.tank_id;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/filtering/" +
                        this.id_tank +
                        "/" +
                        this.tip_vina_tank +
                        "/" +
                        this.faza,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      // this.tank_to_items = response.data;

                      this.tank_to_items_init = response.data;
                      this.tank_to_items_init.splice(0, 0, {
                        id: 0,
                        name: undefined,
                        phaseMark: undefined,
                      });

                      // // console.log(this.tank_to_items_init);

                      this.tank_to_items = this.tank_to_items_init;

                      if (this.tank_id !== 0)
                        this.tank_to_select = this.tank_id;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    newSifarnik() {
      if (this.tank_to_select !== undefined) {
        let w_q = 0;
        if (
          this.filtering_quantity !== undefined &&
          this.filtering_quantity !== null
        )
          w_q = Number(
            this.jm_dolivanja_select.mark === "l"
              ? this.filtering_quantity
              : this.filtering_quantity * 100
          );

        let s_q = 0;
        if (
          this.sediment_quantity !== undefined &&
          this.sediment_quantity !== null
        )
          s_q = Number(
            this.jm_sediment_select.mark === "l"
              ? this.sediment_quantity
              : this.sediment_quantity * 100
          );

        let o_q = 0;
        if (this.outage_quantity !== undefined && this.outage_quantity !== null)
          o_q = Number(
            this.jm_outage_select.mark === "l"
              ? this.outage_quantity
              : this.outage_quantity * 100
          );

        // if (
        //   this.tank_type === "batch" &&
        //   this.kolicina_vina_barici !== w_q + s_q + o_q &&
        //   this.sarza_select.length > 0
        // ) {
        //   this.isLoading = false;
        //   alert(
        //     "Zapremina izabranih barika je različita od ukupne količine vina, taloga i rastura."
        //   );
        // } else {
          let pomKolicina = 0;
          if (!isNaN(this.filtering_quantity))
            pomKolicina = Number(this.filtering_quantity);

          let pomRastur = 0;
          if (!isNaN(this.outage_quantity))
            pomRastur = Number(this.outage_quantity);

          let pomTalog = 0;
          if (!isNaN(this.sediment_quantity))
            pomTalog = Number(this.sediment_quantity);

          var complexObjectSarza = [];

          if (this.tank_type === "batch") {
            let objekat;

            if (this.sarza_select !== undefined) {
              this.sarza_select.forEach(function (entry) {
                if (entry.tank.id !== undefined)
                  objekat = {
                    tank: {
                      id: entry.tank.id,
                    },
                  };
                else
                  objekat = {
                    tank: {
                      id: entry,
                    },
                  };
                complexObjectSarza.push(objekat);
              });
            }
          }

          let pomOpis = "";

          if (typeof this.opis !== "undefined") pomOpis = this.opis;

          this.items_modal = this.format(
            JSON.stringify(this.items_modal),
            "name"
          );

          var pom_tank_to_select;

          if (this.tank_to_select === null) pom_tank_to_select = "0";
          // if (this.tank_to_select.id == null)
          //   pom_tank_to_select = this.tank_to_select;
          // else {
          //   pom_tank_to_select = this.tank_to_select.id;
          // }

          if (typeof this.tank_to_select === "undefined")
            pom_tank_to_select = "0";
          else if (this.tank_to_select.id == null)
            pom_tank_to_select = this.tank_to_select;
          else pom_tank_to_select = this.tank_to_select.id;

          var pom_jm_dolivanja_select;
          if (this.jm_dolivanja_select === null) pom_jm_dolivanja_select = "0";
          if (typeof this.jm_dolivanja_select === "undefined")
            pom_jm_dolivanja_select = "0";
          else if (this.jm_dolivanja_select.id == null)
            pom_jm_dolivanja_select = this.jm_dolivanja_select;
          else pom_jm_dolivanja_select = this.jm_dolivanja_select.id;

          var pom_jm_sediment_select;
          if (this.jm_sediment_select === null)
            pom_jm_sediment_select = undefined;
          else if (typeof this.jm_sediment_select === "undefined")
            pom_jm_sediment_select = undefined;
          else if (this.jm_sediment_select.id == null)
            pom_jm_sediment_select = this.jm_sediment_select;
          else pom_jm_sediment_select = this.jm_sediment_select.id;

          var pom_jm_outage_select;

          if (this.jm_outage_select === null) pom_jm_outage_select = undefined;
          else if (typeof this.jm_outage_select === "undefined")
            pom_jm_outage_select = undefined;
          else if (this.jm_outage_select.id == null)
            pom_jm_outage_select = this.jm_outage_select;
          else pom_jm_outage_select = this.jm_outage_select.id;

          var complexObject;

          if (Number(pomKolicina) === 0) {
            this.isLoading = false;
            alert("Uneta količina ne sme imati vrednost nula.");
          } else {
            if (
              typeof this.outage_quantity !== "undefined" &&
              this.outage_quantity !== ""
            )
              if (
                typeof this.sediment_quantity !== "undefined" &&
                this.sediment_quantity !== "" &&
                this.sediment_quantity !== null
              )
                complexObject = {
                  decanting: {
                    tankPhaseWineId: this.id_tank_phase_wine,
                    toTankId: pom_tank_to_select,
                    quantity: this.filtering_quantity,
                    quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                    outage: this.outage_quantity,
                    outageUnitOfMeasureId: pom_jm_outage_select,
                    sediment: this.sediment_quantity,
                    sedimentUnitOfMeasureId: pom_jm_sediment_select,
                    decantingDate: this.date + "T" + this.time,
                    description: pomOpis,
                    tankFromBatchInOperations: complexObjectSarza,
                  },
                  filteringAdditives: this.items_modal,
                };
              else
                complexObject = {
                  decanting: {
                    tankPhaseWineId: this.id_tank_phase_wine,
                    toTankId: pom_tank_to_select,
                    quantity: this.filtering_quantity,
                    quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                    outage: this.outage_quantity,
                    outageUnitOfMeasureId: pom_jm_outage_select,
                    decantingDate: this.date + "T" + this.time,
                    description: pomOpis,
                    tankFromBatchInOperations: complexObjectSarza,
                  },
                  filteringAdditives: this.items_modal,
                };
            else if (
              typeof this.sediment_quantity !== "undefined" &&
              this.sediment_quantity !== "" &&
              this.sediment_quantity !== null
            )
              complexObject = {
                decanting: {
                  tankPhaseWineId: this.id_tank_phase_wine,
                  toTankId: pom_tank_to_select,
                  quantity: this.filtering_quantity,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  sediment: this.sediment_quantity,
                  sedimentUnitOfMeasureId: pom_jm_sediment_select,
                  decantingDate: this.date + "T" + this.time,
                  description: pomOpis,
                  tankFromBatchInOperations: complexObjectSarza,
                },
                filteringAdditives: this.items_modal,
              };
            else
              complexObject = {
                decanting: {
                  tankPhaseWineId: this.id_tank_phase_wine,
                  toTankId: pom_tank_to_select,
                  quantity: this.filtering_quantity,
                  quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                  decantingDate: this.date + "T" + this.time,
                  description: pomOpis,
                  tankFromBatchInOperations: complexObjectSarza,
                },
                filteringAdditives: this.items_modal,
              };

            this.$http
              .post(
                this.globalServiceLocation +
                  this.globalPort +
                  "/filtering/create",
                complexObject,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer  " + localStorage.getItem("user-token"),
                  },
                }
              )
              .then((response) => {
                this.isLoading = false;

                if (this.id_tank_phase_wine === 0) {
                  this.id_tank_phase_wine = response.data.id;
                  this.ID = response.data.id;
                }

                if (response.data.isEmptyTank) {
                  this.id_tank_phase_wine = 0;
                  this.kolicinaVina = 0;
                  this.isEmptyTank = true;
                } else {
                  let s_q = 0;
                  if (this.sediment_quantity !== undefined)
                    s_q = Number(this.sediment_quantity);

                  let o_q = 0;
                  if (this.outage_quantity !== undefined)
                    o_q = Number(this.outage_quantity);

                  this.kolicinaVina =
                    Number(this.kolicinaVinaPom) -
                    Number(this.filtering_quantity) -
                    s_q -
                    o_q;
                }

                serverBus.$emit("refresh_filtering", this.id_tank_phase_wine);

                this.clear();
              })
              .catch((e) => {
                // // console.log(e.response);

                if (!e.response) {
                  this.isLoading = false;
                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        // // console.log(result);
                        // // console.log("Novi token - " + localStorage.getItem("user-token"));

                        this.$http
                          .post(
                            this.globalServiceLocation +
                              this.globalPort +
                              "/filtering/create",
                            complexObject,
                            {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                  "Bearer  " +
                                  localStorage.getItem("user-token"),
                              },
                            }
                          )
                          .then((response) => {
                            this.isLoading = false;

                            if (this.id_tank_phase_wine === 0) {
                              this.id_tank_phase_wine = response.data.id;
                              this.ID = response.data.id;
                            }

                            if (response.data.isEmptyTank) {
                              this.id_tank_phase_wine = 0;
                              this.kolicinaVina = 0;
                              this.isEmptyTank = true;
                            } else {
                              let s_q = 0;
                              if (this.sediment_quantity !== undefined)
                                s_q = Number(this.sediment_quantity);

                              let o_q = 0;
                              if (this.outage_quantity !== undefined)
                                o_q = Number(this.outage_quantity);

                              this.kolicinaVina =
                                Number(this.kolicinaVinaPom) -
                                Number(this.filtering_quantity) -
                                s_q -
                                o_q;
                            }

                            serverBus.$emit(
                              "refresh_filtering",
                              this.id_tank_phase_wine
                            );

                            this.clear();
                          })
                          .catch((e) => {
                            this.isLoading = false;

                            let pomError = readJSON(e.response.data.message);
                            alert(pomError);
                          });
                      });
                  } else {
                    this.isLoading = false;

                    let pomError = readJSON(e.response.data.message);
                    alert(pomError);
                  }
                }
              });
          }
        // }
      }
    },
    format(json_string, key_to_skip) {
      return JSON.parse(json_string, function (key, value) {
        if (key !== key_to_skip) {
          return value;
        }
      });
    },
    changeSarza(a) {
      if (a !== undefined) {
        this.kolicina_vina_barici = 0;

        if (this.sarza_select.length > 0) {
          if (this.sarza_select !== undefined) {
            this.jm_dolivanja_select = this.sarza_select[0].tank.unitOfMeasure;

            let _this = this;

            this.sarza_select.forEach(function (entry) {
              if (entry.tank.unitOfMeasure.mark === "l")
                _this.kolicina_vina_barici =
                  _this.kolicina_vina_barici + entry.tank.capacity;
              else
                _this.kolicina_vina_barici =
                  _this.kolicina_vina_barici + entry.tank.capacity * 100;
            });
          }

          if (!this.applied)
            this.filtering_quantity = this.kolicina_vina_barici;
          else this.applied = false;
        }
        // else
        // {
        //    this.jm_dolivanja_select = undefined;
        //     this.filtering_quantity = undefined;
        // }
      }
    },
    changeSifarnik() {
      let w_q = 0;
      if (
        this.filtering_quantity !== undefined &&
        this.filtering_quantity !== null
      )
        w_q = Number(this.filtering_quantity);

      let s_q = 0;
      if (
        this.sediment_quantity !== undefined &&
        this.sediment_quantity !== null
      )
        s_q = Number(this.sediment_quantity);

      let o_q = 0;
      if (this.outage_quantity !== undefined && this.outage_quantity !== null)
        o_q = Number(this.outage_quantity);

      // if (
      //   this.tank_type === "batch" &&
      //   this.kolicina_vina_barici !== w_q + s_q + o_q &&
      //   this.sarza_select.length > 0
      // ) {
      //   this.isLoading = false;
      //   alert(
      //     "Zapremina izabranih barika je različita od ukupne količine vina, taloga i rastura."
      //   );
      // } else {
        let pomKolicina = 0;
        if (!isNaN(this.filtering_quantity))
          pomKolicina = Number(this.filtering_quantity);

        let pomRastur = 0;
        if (!isNaN(this.outage_quantity))
          pomRastur = Number(this.outage_quantity);

        let pomTalog = 0;
        if (!isNaN(this.sediment_quantity))
          pomTalog = Number(this.sediment_quantity);

        var complexObjectSarza = [];

        if (this.tank_type === "batch") {
          let objekat;

          if (this.sarza_select !== undefined) {
            let _this = this;

            this.sarza_select.forEach(function (entry) {
              if (entry.id !== undefined)
                objekat = {
                  id: entry.id,
                  tank: {
                    id: entry.tank.id,
                  },
                };
              else {
                let ind = _this.izabrani_barici.findIndex(
                  (x) => x.tank.id === entry
                );

                if (ind >= 0) {
                  objekat = {
                    id: _this.izabrani_barici[ind].id,
                    tank: {
                      id: entry,
                    },
                  };
                } else
                  objekat = {
                    tank: {
                      id: entry,
                    },
                  };
              }

              complexObjectSarza.push(objekat);
            });
          }
        }

        let pomOpis = "";

        if (typeof this.opis !== "undefined") pomOpis = this.opis;

        this.items_modal = this.format(
          JSON.stringify(this.items_modal),
          "name"
        );

        var pom_tank_to_select;

        if (this.tank_to_select.id == null)
          pom_tank_to_select = this.tank_to_select;
        else {
          pom_tank_to_select = this.tank_to_select.id;
        }

        var pom_jm_dolivanja_select;
        if (this.jm_dolivanja_select === null) pom_jm_dolivanja_select = "0";
        if (typeof this.jm_dolivanja_select === "undefined")
          pom_jm_dolivanja_select = "0";
        else if (this.jm_dolivanja_select.id == null)
          pom_jm_dolivanja_select = this.jm_dolivanja_select;
        else pom_jm_dolivanja_select = this.jm_dolivanja_select.id;

        var pom_jm_sediment_select;

        // // console.log(this.jm_sediment_select);

        if (this.jm_sediment_select === null || this.jm_sediment_select === "")
          pom_jm_sediment_select = "0";
        else if (typeof this.jm_sediment_select === "undefined")
          pom_jm_sediment_select = "0";
        else if (this.jm_sediment_select.id == null)
          pom_jm_sediment_select = this.jm_sediment_select;
        else pom_jm_sediment_select = this.jm_sediment_select.id;

        var pom_jm_outage_select;

        if (this.jm_outage_select === null) pom_jm_outage_select = "0";
        else if (typeof this.jm_outage_select === "undefined")
          pom_jm_outage_select = "0";
        else if (this.jm_outage_select.id == null)
          pom_jm_outage_select = this.jm_outage_select;
        else pom_jm_outage_select = this.jm_outage_select.id;

        var complexObject;

        if (Number(pomKolicina) === 0) {
          this.isLoading = false;
          alert("Uneta količina ne sme imati vrednost nula.");
        } else {
          if (
            typeof this.outage_quantity !== "undefined" &&
            this.outage_quantity !== ""
          )
            if (
              typeof this.sediment_quantity !== "undefined" &&
              this.sediment_quantity !== "" &&
              this.sediment_quantity !== null
            )
              complexObject = {
                tankPhaseWineId: this.id_tank_phase_wine,
                toTankId: pom_tank_to_select,
                quantity: this.filtering_quantity,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                outage: this.outage_quantity,
                outageUnitOfMeasureId: pom_jm_outage_select,
                sediment: this.sediment_quantity,
                sedimentUnitOfMeasureId: pom_jm_sediment_select,
                decantingDate: this.date + "T" + this.time,
                description: pomOpis,
                tankFromBatchInOperations: complexObjectSarza,
              };
            else
              complexObject = {
                tankPhaseWineId: this.id_tank_phase_wine,
                toTankId: pom_tank_to_select,
                quantity: this.filtering_quantity,
                quantityUnitOfMeasureId: pom_jm_dolivanja_select,
                outage: this.outage_quantity,
                outageUnitOfMeasureId: pom_jm_outage_select,
                decantingDate: this.date + "T" + this.time,
                description: pomOpis,
                tankFromBatchInOperations: complexObjectSarza,
              };
          else if (
            typeof this.sediment_quantity !== "undefined" &&
            this.sediment_quantity !== "" &&
            this.sediment_quantity !== null
          )
            complexObject = {
              tankPhaseWineId: this.id_tank_phase_wine,
              toTankId: pom_tank_to_select,
              quantity: this.filtering_quantity,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              sediment: this.sediment_quantity,
              sedimentUnitOfMeasureId: pom_jm_sediment_select,
              decantingDate: this.date + "T" + this.time,
              description: pomOpis,
              tankFromBatchInOperations: complexObjectSarza,
            };
          else
            complexObject = {
              tankPhaseWineId: this.id_tank_phase_wine,
              toTankId: pom_tank_to_select,
              quantity: this.filtering_quantity,
              quantityUnitOfMeasureId: pom_jm_dolivanja_select,
              decantingDate: this.date + "T" + this.time,
              description: pomOpis,
              tankFromBatchInOperations: complexObjectSarza,
            };

          // // console.log(JSON.stringify(complexObject));

          this.$http
            .put(
              this.globalServiceLocation +
                this.globalPort +
                "/filtering/update/" +
                this.ID,
              complexObject,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              }
            )
            .then((response) => {
              this.isLoading = false;

              if (this.id_tank_phase_wine === 0) {
                this.id_tank_phase_wine = response.data.id;
              }

              if (response.data.isEmptyTank) {
                // this.id_tank_phase_wine = 0;
                this.kolicinaVina = 0;
                this.isEmptyTank = true;
              } else {
                let s_q = 0;
                if (this.sediment_quantity !== undefined)
                  s_q = Number(this.sediment_quantity);

                let o_q = 0;
                if (this.outage_quantity !== undefined)
                  o_q = Number(this.outage_quantity);

                this.kolicinaVina =
                  Number(this.kolicinaVinaPom) -
                  Number(this.filtering_quantity) -
                  s_q -
                  o_q;
              }

              serverBus.$emit("refresh_filtering", this.id_tank_phase_wine);

              this.clear();
            })
            .catch((e) => {
              // // console.log(e.response);

              if (!e.response) {
                this.isLoading = false;
                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      // // console.log(result);
                      // // console.log("Novi token - " + localStorage.getItem("user-token"));

                      this.$http
                        .put(
                          this.globalServiceLocation +
                            this.globalPort +
                            "/filtering/update/" +
                            this.ID,
                          complexObject,
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          this.isLoading = false;

                          if (this.id_tank_phase_wine === 0) {
                            this.id_tank_phase_wine = response.data.id;
                          }

                          if (response.data.isEmptyTank) {
                            // this.id_tank_phase_wine = 0;
                            this.kolicinaVina = 0;
                            this.isEmptyTank = true;
                          } else {
                            let s_q = 0;
                            if (this.sediment_quantity !== undefined)
                              s_q = Number(this.sediment_quantity);

                            let o_q = 0;
                            if (this.outage_quantity !== undefined)
                              o_q = Number(this.outage_quantity);

                            this.kolicinaVina =
                              Number(this.kolicinaVinaPom) -
                              Number(this.filtering_quantity) -
                              s_q -
                              o_q;
                          }

                          serverBus.$emit(
                            "refresh_filtering",
                            this.id_tank_phase_wine
                          );

                          this.clear();
                        })
                        .catch((e) => {
                          this.isLoading = false;

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  this.isLoading = false;

                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        }
      // }
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.$refs.element1.validate()) {
          this.isLoading = true;

          setTimeout(() => {
            if (this.ID != "" && this.ID != "0") this.changeSifarnik();
            else this.newSifarnik();

            // this.isLoading = false;
          }, 1000);
        } else alert("Niste odabrali tank u koji se filtrira.");
      }
    },
    submit_modal() {
      if (this.$refs.form_modal.validate()) {
        var complexfilteringAdditive;
        var complexfilteringAdditivePom;

        if (this.ID === 0) {
          var complexObjectUnitOfMeasure = {
            id: this.jm_select.id,
            name: this.jm_select.name,
            mark: this.jm_select.mark,
          };

          var complexAdditiv = {
            id: this.aditiv_select.id,
            name: this.aditiv_select.name,
          };

          if (typeof this.opis_modal === "undefined") {
            complexfilteringAdditive = {
              additiv: complexAdditiv,
              quantity: Number(this.kolicina_modal),
              unitOfMeasure: complexObjectUnitOfMeasure,
              description: "",
              materialFromWarehouseDocumentItems:
                this.materialFromWarehouseDocumentItemList,
            };

            complexfilteringAdditivePom = {
              idAditiveGroup: this.additiv_group_to_select,
              additiv: complexAdditiv,
              quantity: Number(this.kolicina_modal),
              unitOfMeasure: complexObjectUnitOfMeasure,
              description: "",
              materialFromWarehouseDocumentItems:
                this.materialFromWarehouseDocumentItemList,
            };
          } else {
            complexfilteringAdditive = {
              additiv: complexAdditiv,
              quantity: Number(this.kolicina_modal),
              unitOfMeasure: complexObjectUnitOfMeasure,
              description: this.opis_modal,
              materialFromWarehouseDocumentItems:
                this.materialFromWarehouseDocumentItemList,
            };

            complexfilteringAdditivePom = {
              idAditiveGroup: this.additiv_group_to_select,
              additiv: complexAdditiv,
              quantity: Number(this.kolicina_modal),
              unitOfMeasure: complexObjectUnitOfMeasure,
              description: this.opis_modal,
              materialFromWarehouseDocumentItems:
                this.materialFromWarehouseDocumentItemList,
            };
          }

          if (this.index_izmene !== -1) {
            this.items_modal.splice(this.index_izmene, this.index_izmene + 1);
          }

          this.items_modal.push(complexfilteringAdditivePom);

          this.clear_modal();
        } else {
          if (Number(this.index_izmene) === -1) {
            var complexObjectTankPhaseWineBlend = {
              id: this.ID,
            };
            var complexObjectUnitOfMeasure = {
              id: this.jm_select.id,
            };

            var complexAdditiv = {
              id: this.aditiv_select.id,
            };

            if (typeof this.opis_modal === "undefined")
              complexfilteringAdditive = {
                tankPhaseWineBlend: complexObjectTankPhaseWineBlend,
                additiv: complexAdditiv,
                quantity: Number(this.kolicina_modal),
                unitOfMeasure: complexObjectUnitOfMeasure,
                description: "",
                materialFromWarehouseDocumentItems:
                  this.materialFromWarehouseDocumentItemList,
              };
            else
              complexfilteringAdditive = {
                tankPhaseWineBlend: complexObjectTankPhaseWineBlend,
                additiv: complexAdditiv,
                quantity: Number(this.kolicina_modal),
                unitOfMeasure: complexObjectUnitOfMeasure,
                description: this.opis_modal,
                materialFromWarehouseDocumentItems:
                  this.materialFromWarehouseDocumentItemList,
              };

            // // console.log(JSON.stringify(complexfilteringAdditive));

            this.$http
              .post(
                this.globalServiceLocation +
                  this.globalPort +
                  "/filtering/additiv/create",
                complexfilteringAdditive,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer  " + localStorage.getItem("user-token"),
                  },
                }
              )
              .then((response) => {
                // // console.log(response.data);

                this.clear_modal();
                serverBus.$emit("refresh_filtering", this.id_tank_phase_wine);

                this.getAllSifarnik();
              })
              .catch((e) => {
                // // console.log(e.response);

                if (!e.response) {
                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        // // console.log(result);
                        // // console.log("Novi token - " + localStorage.getItem("user-token"));

                        this.$http
                          .post(
                            this.globalServiceLocation +
                              this.globalPort +
                              "/filtering/additiv/create",
                            complexfilteringAdditive,
                            {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                  "Bearer  " +
                                  localStorage.getItem("user-token"),
                              },
                            }
                          )
                          .then((response) => {
                            // // console.log(response.data);

                            this.clear_modal();
                            serverBus.$emit(
                              "refresh_filtering",
                              this.id_tank_phase_wine
                            );

                            this.getAllSifarnik();
                          })
                          .catch((e) => {
                            // // console.log(e.response);

                            let pomError = readJSON(e.response.data.message);
                            alert(pomError);
                          });
                      });
                  } else {
                    let pomError = readJSON(e.response.data.message);
                    alert(pomError);
                  }
                }
              });
          } else {
            var complexObjectTankPhaseWineBlend = {
              id: this.ID,
            };
            var complexObjectUnitOfMeasure = {
              id: this.jm_select.id,
            };

            var complexAdditiv = {
              id: this.aditiv_select.id,
            };

            if (typeof this.opis_modal === "undefined")
              complexfilteringAdditive = {
                id: this.ID_aditiv,
                tankPhaseWineBlend: complexObjectTankPhaseWineBlend,
                additiv: complexAdditiv,
                quantity: Number(this.kolicina_modal),
                unitOfMeasure: complexObjectUnitOfMeasure,
                description: "",
                materialFromWarehouseDocumentItems:
                  this.materialFromWarehouseDocumentItemList,
              };
            else
              complexfilteringAdditive = {
                id: this.ID_aditiv,
                tankPhaseWineBlend: complexObjectTankPhaseWineBlend,
                additiv: complexAdditiv,
                quantity: Number(this.kolicina_modal),
                unitOfMeasure: complexObjectUnitOfMeasure,
                description: this.opis_modal,
                materialFromWarehouseDocumentItems:
                  this.materialFromWarehouseDocumentItemList,
              };

            // // console.log(JSON.stringify(complexfilteringAdditive));

            this.$http
              .put(
                this.globalServiceLocation +
                  this.globalPort +
                  "/filtering/additiv/update",
                complexfilteringAdditive,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization:
                      "Bearer  " + localStorage.getItem("user-token"),
                  },
                }
              )
              .then((response) => {
                this.clear_modal();
                serverBus.$emit("refresh_filtering", this.id_tank_phase_wine);
                this.getAllSifarnik();
              })
              .catch((e) => {
                // // console.log(e.response);

                if (!e.response) {
                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        // // console.log(result);
                        // // console.log("Novi token - " + localStorage.getItem("user-token"));

                        this.$http
                          .put(
                            this.globalServiceLocation +
                              this.globalPort +
                              "/filtering/additiv/update",
                            complexfilteringAdditive,
                            {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization:
                                  "Bearer  " +
                                  localStorage.getItem("user-token"),
                              },
                            }
                          )
                          .then((response) => {
                            this.clear_modal();
                            serverBus.$emit(
                              "refresh_filtering",
                              this.id_tank_phase_wine
                            );
                            this.getAllSifarnik();
                          })
                          .catch((e) => {
                            // // console.log(e.response);

                            let pomError = readJSON(e.response.data.message);
                            alert(pomError);
                          });
                      });
                  } else {
                    let pomError = readJSON(e.response.data.message);
                    alert(pomError);
                  }
                }
              });
          }
        }
      }
    },
    otvoriModal() {
      //         if (this.ID === 0)
      //         alert('Nije izabrano filtriranje.')
      //         else{
      //           this.dialogNote = true
      // this.getAllSifarnik()
      //         }

      this.dialogNote = true;
      this.getAllSifarnik();
    },
    clear() {
      this.setTime();
      this.setDate();

      this.$refs.form.reset();
      this.$refs.element1.reset();

      this.ID = 0;

      this.items_modal = [];

      this.kolicinaVinaPom = Number(this.kolicinaVina);

      if (this.tank_type === "batch") this.getAllSarze(this.id_tank, null);
    },
    clear_modal() {
      this.index_izmene = -1;
      this.$refs.form_modal.reset();
      // alert('ocisti modal')

      // alert(this.ID);

      this.materialOperationId = 0;
      this.selectedArticle = 0;
      this.selectedArticleName = "";

      this.izabrani_aditivi = [];

      this.izmena_aditiva = false;

      this.ID_aditiv = 0;
    },
    clear_modal_init() {
      this.clear_modal();

      this.materialFromWarehouseDocumentItemList = [];
    },
    changeRoute(a) {
      if (typeof a !== "undefined") {
        if (a.id === undefined) {
          if (a !== undefined) {
            // this.PreostaloUTanku(a);
          }
        } else {
          // this.filtering_quantity = undefined;
          this.PreostaloUTanku(a.id);
        }
      }
    },
    PreostaloUTanku(idTank) {
      if (typeof idTank !== "undefined" && typeof idTank !== "object" && idTank !== 0)
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/tank/" +
              idTank +
              "/free_space",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            // // console.log(idTank);
            // // console.log(this.filtering_quantity);

            if (
              typeof this.filtering_quantity === "undefined" ||
              this.filtering_quantity === "undefined"
            ) {
              this.preostalo_izabrani_tank = Number(
                response.data.freeSpaceInTank
              );
            } else
              this.preostalo_izabrani_tank =
                Number(response.data.freeSpaceInTank) +
                Number(this.filtering_quantity);

            // alert(this.preostalo_izabrani_tank);

            this.preostalo_izabrani_tank_jm = response.data.unitOfMeasure.mark;
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/tank/" +
                          idTank +
                          "/free_space",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // console.log(idTank);
                        // // console.log(this.filtering_quantity);

                        if (
                          typeof this.filtering_quantity === "undefined" ||
                          this.filtering_quantity === "undefined"
                        ) {
                          this.preostalo_izabrani_tank = Number(
                            response.data.freeSpaceInTank
                          );
                        } else
                          this.preostalo_izabrani_tank =
                            Number(response.data.freeSpaceInTank) +
                            Number(this.filtering_quantity);

                        // alert(this.preostalo_izabrani_tank);

                        this.preostalo_izabrani_tank_jm =
                          response.data.unitOfMeasure.mark;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        pomError = pomError
                          .replace("toTankOld", this.tank_to_select_name_stara)
                          .replace("toTankNew", this.tank_to_select_name_nova)
                          .replace("fromTankOld", "")
                          .replace("fromTank", "");

                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
    },
    getAllJediniceMere() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/unit_of_measure/group/1",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let niz = [];
          let litar;

          response.data.forEach(function (entry) {
            if (entry.mark !== "ml") niz.push(entry);

            if (entry.mark === "l") litar = entry;
          });

          this.jm_items = niz;
          this.jm_outage_items = niz;
          this.jm_sediment_items = niz;

          this.jm_dolivanja_select = litar;
          this.jm_outage_select = litar;
          this.jm_sediment_select = litar;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/unit_of_measure/group/1",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let niz = [];
                      let litar;

                      response.data.forEach(function (entry) {
                        if (entry.mark !== "ml") niz.push(entry);

                        if (entry.mark === "l") litar = entry;
                      });

                      this.jm_items = niz;
                      this.jm_outage_items = niz;
                      this.jm_sediment_items = niz;

                      this.jm_dolivanja_select = litar;
                      this.jm_outage_select = litar;
                      this.jm_sediment_select = litar;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllJediniceMereAditiv(a) {
      if (typeof a !== "undefined")
        if (typeof a.id !== "undefined") {
          let ind = 0;
          ind = this.aditiv_items.findIndex((x) => x.id === a.id);

          if (ind >= 0) {
            this.selectedArticle = this.aditiv_items[ind].id;
            this.selectedArticleName = this.aditiv_items[ind].name;
          }

          this.$http
            .get(
              this.globalServiceLocation +
                this.globalPort +
                "/additiv/" +
                a.id +
                "/with_unit",
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              }
            )
            .then((response) => {
              //// // console.log(response.data);

              this.jm_items_dodatak = response.data.unitOfMeasure;

              if (response.data.unitOfMeasure.length === 1)
                this.jm_select = response.data.unitOfMeasure[0];
            })
            .catch((e) => {
              // // console.log(e.response);

              if (!e.response) {
                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      // // console.log(result);
                      // // console.log("Novi token - " + localStorage.getItem("user-token"));

                      this.$http
                        .get(
                          this.globalServiceLocation +
                            this.globalPort +
                            "/additiv/" +
                            a.id +
                            "/with_unit",
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          //// // console.log(response.data);

                          this.jm_items_dodatak = response.data.unitOfMeasure;

                          if (response.data.unitOfMeasure.length === 1)
                            this.jm_select = response.data.unitOfMeasure[0];
                        })
                        .catch((e) => {
                          // // console.log(e.response);

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        } else {
          let ind = 0;
          ind = this.aditiv_items.findIndex((x) => x.id === a);

          if (ind >= 0) {
            this.selectedArticle = this.aditiv_items[ind].id;
            this.selectedArticleName = this.aditiv_items[ind].name;
          }

          this.$http
            .get(
              this.globalServiceLocation +
                this.globalPort +
                "/additiv/" +
                a +
                "/with_unit",
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              }
            )
            .then((response) => {
              //// // console.log(response.data);

              this.jm_items_dodatak = response.data.unitOfMeasure;
            })
            .catch((e) => {
              // // console.log(e.response);

              if (!e.response) {
                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      // // console.log(result);
                      // // console.log("Novi token - " + localStorage.getItem("user-token"));

                      this.$http
                        .get(
                          this.globalServiceLocation +
                            this.globalPort +
                            "/additiv/" +
                            a +
                            "/with_unit",
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          //// // console.log(response.data);

                          this.jm_items_dodatak = response.data.unitOfMeasure;
                        })
                        .catch((e) => {
                          // // console.log(e.response);

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        }
    },
    getAllGroups() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/additiv_group/operation/FILTERING",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          this.additiv_group_to_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/additiv_group/operation/FILTERING",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.additiv_group_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAditives(a, aditivZaSelektovanje) {
      let url = "";

      url =
        this.globalServiceLocation +
        this.globalPort +
        "/additiv_group/" +
        a +
        "/additives";

      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.aditiv_items = response.data;

          if (
            aditivZaSelektovanje !== undefined &&
            aditivZaSelektovanje !== null
          ) {
            let ind = this.aditiv_items.findIndex(
              (x) => x.name === aditivZaSelektovanje
            );

            this.aditiv_select = this.aditiv_items[ind];
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      this.aditiv_items = response.data;

                      if (
                        aditivZaSelektovanje !== undefined &&
                        aditivZaSelektovanje !== null
                      ) {
                        let ind = this.aditiv_items.findIndex(
                          (x) => x.name === aditivZaSelektovanje
                        );

                        this.aditiv_select = this.aditiv_items[ind];
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    editItemModal(item) {
      let pomNiz = [];
      pomNiz.push(item);

      this.popuni_izabrane_aditive(pomNiz);
      // this.clear_modal();
      // console.log(item);

      this.load = 0;

      this.opis_modal = item.description;

      if (item.additiv !== null) {
        if (item.additiv.additiveGroup !== undefined)
          this.additiv_group_to_select = item.additiv.additiveGroup;
        else this.additiv_group_to_select = item.idAditiveGroup;

        this.aditiv_select = item.additiv;

        this.selectedArticle = item.additiv.id;
        this.selectedArticleName = item.additiv.name;

        this.kolicina_modal = item.quantity;
        this.jm_select = item.unitOfMeasure;
        this.materialOperationId = item.id;
        this.additiveQuantity = item.quantity;

        let pomStr = this.jm_select.mark;
        this.jm = pomStr.split("/")[0];

        if (this.jm === "psc") this.brojDec = 0;
        else this.brojDec = 2;
      }

      if (this.ID !== 0) this.ID_aditiv = item.id;

      this.materialFromWarehouseDocumentItemList =
        item.materialFromWarehouseDocumentItems;

      this.index_izmene = this.items_modal.indexOf(item);
    },

    deleteItemModal(item) {
      const index = this.items_modal.indexOf(item);
      this.obrisi_izabrane_aditive(item, index);

      if (this.ID !== undefined && this.ID !== 0)
        confirm("Da li ste sigurni da želite obrisati izabrani zapis?") &&
          this.deleteSifarnik(index, item.id);
    },
    deleteSifarnik(id, id_aditiv) {
      if (this.ID === 0) this.items_modal.splice(id, id + 1);
      else {
        this.$http
          .delete(
            this.globalServiceLocation +
              this.globalPort +
              "/filtering/additiv/delete/" +
              id_aditiv,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            // // console.log(response);

            this.getAllSifarnik();

            this.clear_modal();
            serverBus.$emit("refresh_filtering", this.id_tank_phase_wine);
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .delete(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/filtering/additiv/delete/" +
                          id_aditiv,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // console.log(response);

                        this.getAllSifarnik();

                        this.clear_modal();
                        serverBus.$emit(
                          "refresh_filtering",
                          this.id_tank_phase_wine
                        );
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    changeAditiveGroup(a) {
      this.load = this.load + 1;

      if (this.load > 1) {
        this.selectedArticle = 0;
        this.selectedArticleName = "";
        this.materialOperationId = 0;
        this.kolicina_modal = undefined;
        this.jm_select = undefined;

        this.aditiv_select = undefined;
      }

      if (typeof a !== "undefined") {
        if (a.id === undefined) {
          if (a !== undefined) {
            this.getAditives(a);
          } else if (typeof this.operation_to_select === "undefined") {
            this.operation_to_select = undefined;
          }
        } else {
          this.getAditives(a.id);

          //if (this.load > 1)
          // this.aditiv_select = undefined;
        }
      }
    },
    closeModalInModal() {
      this.clear_modal();
      this.dialogNote = false;

      if (this.ID > 0)
        serverBus.$emit("refresh_filtering", this.id_tank_phase_wine);
    },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
    dialogNote(val) {
      // alert('dialogNote');

      // if (this.ID === 0){
      //   this.items_modal = [];
      // }

      if (val)
        if (
          Number(this.kolicina_modal) !== 0 &&
          this.jm_select !== "" &&
          this.opis_modal !== "" &&
          this.aditiv_select !== ""
        )
          this.$refs.form_modal.reset();

      //val || this.clear_modal();
    },
  },
  mounted() {
    this.clear();
    // this.setTime();
    // this.setDate();

    //this.clear_modal();

    this.getAllJediniceMere();
    this.getAllGroups();

    serverBus.$on("refresh_header", (kolicina, rastur, talog) => {
      this.kolicinaVina =
        Number(this.kolicinaVina) +
        Number(kolicina) +
        Number(rastur) +
        Number(talog);

      this.kolicinaVinaPom = Number(this.kolicinaVina);

      this.clear_modal();
      this.clear();
    });

    serverBus.$on("applied_filtering", (item) => {
      // this.popuni_izabrane_aditive(item.filteringAdditives);

      this.applied = true;

      if (item.decanting.outage !== null)
        this.kolicinaVinaPom =
          Number(this.kolicinaVina) +
          Number(item.decanting.quantity) +
          Number(item.decanting.sediment) +
          Number(item.decanting.outage.quantity);
      else
        this.kolicinaVinaPom =
          Number(this.kolicinaVina) +
          Number(item.decanting.quantity) +
          Number(item.decanting.sediment);

      this.opis = item.decanting.description;

      // this.date = item.date;
      this.date = item.decanting.date.split("T")[0];
      this.time = this.formatTime(item.decanting.date.split("T")[1]);

      this.ID = item.decanting.id;
      if (item.decanting.outage !== null) {
        if (!isNaN(item.decanting.outage.quantity))
          this.outage_quantity = item.decanting.outage.quantity;

        if (
          typeof item.decanting.outage.unitOfMeasure !== "undefined" &&
          item.decanting.outage.unitOfMeasure !== null
        ) {
          this.jm_outage_select = item.decanting.outage.unitOfMeasure;
        } else {
          this.jm_outage_select = "";
        }
      } else {
        this.outage_quantity = undefined;
        this.jm_outage_select = undefined;
      }

      this.filtering_quantity = item.decanting.quantity;

      if (typeof item.decanting.unitOfMeasure !== "undefined") {
        this.jm_dolivanja_select = item.decanting.unitOfMeasure;
      } else {
        this.jm_dolivanja_select = "";
      }

      if (!isNaN(item.decanting.sediment))
        this.sediment_quantity = item.decanting.sediment;

      if (
        typeof item.decanting.sedimentUnitOfMeasure !== "undefined" &&
        item.decanting.sedimentUnitOfMeasure !== null
      ) {
        this.jm_sediment_select = item.decanting.sedimentUnitOfMeasure;
      } else {
        this.jm_sediment_select = "";
      }

      this.items_modal = item.filteringAdditives;

      let addNew = false;

      let duzinaNiza = this.tank_to_items_init.length;

      for (var i = 0; i < duzinaNiza; i++) {
        if (this.tank_to_items_init[i].id === item.decanting.tankId)
          addNew = true;
        this.tank_to_items.push(this.tank_to_items_init[i]);
      }

      if (item.decanting.tankFromBatchInOperations.length > 0) {
        let objPom = [];

        if (this.ID !== 0 && item !== null) {
          let _this = this;

          item.decanting.tankFromBatchInOperations.forEach(function (entry) {
            objPom.push(entry);

            let pomocniObj;
            pomocniObj = {
              batchPrefix: entry.tank.batchPrefix.split("-")[0],
              batchTank: null,
              id: 777,
              tank: {
                capacity: entry.tank.capacity,
                id: entry.tank.id,
                inventoryNumber: entry.tank.inventoryNumber,
                name: entry.tank.name,
                unitOfMeasure: entry.tank.unitOfMeasure,
              },
              tankNumberInBatch: entry.tank.batchPrefix.split("-")[1],
            };
            _this.sarza_items.push(pomocniObj);
          });

          // this.sarza_items.sort( this.compare );

          this.sarza_select = objPom;
          this.izabrani_barici = objPom;
        }
      } else if (this.ID !== 0 && item !== null) {
        this.sarza_select = [];
        this.izabrani_barici = [];
      }

      if (!addNew) {
        let phaseName = "";

        if (item.phaseName === "Alkoholna fermentacija") phaseName = "AF";
        else if (item.phaseName === "Malolaktička fermentacija")
          phaseName = "MF";
        else if (item.phaseName === "Alkoholna malolaktička fermentacija")
          phaseName = "AM";
        else if (item.phaseName === "Odležavanje") phaseName = "OD";
        else phaseName = "ZA";

        this.tank_to_items.splice(1, 0, {
          id: item.decanting.tankId,
          name: item.decanting.tankName,
          phaseMark: phaseName,
        });
      }

      this.tank_to_select = item.decanting.tankId;
      this.tank_id = item.decanting.tankId;

      this.$refs.form_modal.reset();
    });

    serverBus.$on("otvori_modal", (item) => {
      // this.popuni_izabrane_aditive(item.filteringAdditives);

      this.opis = item.decanting.description;

      this.kolicinaVinaPom =
        Number(this.kolicinaVina) + Number(item.decanting.quantity);

      // this.date = item.date;
      this.date = item.decanting.date.split("T")[0];
      this.time = this.formatTime(item.decanting.date.split("T")[1]);

      this.ID = item.decanting.id;
      if (item.decanting.outage !== null) {
        if (!isNaN(item.decanting.outage.quantity))
          this.outage_quantity = item.decanting.outage.quantity;

        if (
          typeof item.decanting.outage.unitOfMeasure !== "undefined" &&
          item.decanting.outage.unitOfMeasure !== null
        ) {
          this.jm_outage_select = item.decanting.outage.unitOfMeasure.id;
        } else {
          this.jm_outage_select = "";
        }
      } else {
        this.outage_quantity = undefined;
        this.jm_outage_select = undefined;
      }

      this.filtering_quantity = item.decanting.quantity;

      if (typeof item.decanting.unitOfMeasure !== "undefined") {
        this.jm_dolivanja_select = item.decanting.unitOfMeasure.id;
      } else {
        this.jm_dolivanja_select = "";
      }

      if (!isNaN(item.decanting.sediment))
        this.sediment_quantity = item.decanting.sediment;

      if (
        typeof item.decanting.sedimentUnitOfMeasure !== "undefined" &&
        item.decanting.sedimentUnitOfMeasure !== null
      ) {
        this.jm_sediment_select = item.decanting.sedimentUnitOfMeasure.id;
      } else {
        this.jm_sediment_select = "";
      }

      this.items_modal = item.filteringAdditives;

      this.tank_to_select = item.decanting.tankId;
      this.tank_id = item.decanting.tankId;

      this.dialogNote = true;

      this.$refs.form_modal.reset();
    });

    serverBus.$on("clear_filtering", () => {
      this.clear();
    });

    // serverBus.$on("filtering", id => {
    //   // alert('pouring');
    //   // alert(id);

    //   // // // console.log(operation);

    //   this.id_tank_phase_wine = id;

    //   // this.getAllGroups();
    // });

    serverBus.$on(
      "filtering",
      (
        id_tank_phase_wine,
        id_tank,
        kolicina_vina,
        faza,
        tip_vina,
        vino_id,
        id_akcije,
        id_jm,
        faza_mark,
        jm_mark,
        tank_type,
        edit
      ) => {
        this.id_tank_phase_wine = Number(id_tank_phase_wine);
        this.id_tank = id_tank;

        if (typeof edit !== "undefined") this.edit = edit;
        else this.edit = true;

        this.kolicinaVina = kolicina_vina;
        this.kolicinaVinaPom = this.kolicinaVina;

        this.faza = faza;
        this.id_jedinica_mere = id_jm;

        this.faza_mark = faza_mark;
        this.jm_mark = jm_mark;

        // this.phase_to_select = faza;

        this.tipVina = tip_vina;
        this.tip_vina_tank = Number(vino_id);

        this.getAllTankovi(false);

        if (tank_type === "press") this.tekst_labele_1 = "Komina";
        else if (Number(this.faza) === 1 && Number(this.tipVina) !== 2)
          this.tekst_labele_1 = "Komine";
        else this.tekst_labele_1 = "Taloga";

        // this.getAllGroups();

        this.PreostaloUTanku(id_tank);

        this.tank_type = tank_type;

        if (tank_type === "batch") this.getAllSarze(id_tank, null);
      }
    );
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/sass/parts/modalStyles";

.filteringItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

// .v-input.v-text-field {
// 	margin: 0px;
// }
div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

#FloatingButton {
  position: absolute;
  width: 54px;
  height: 54px;
  font-size: 25px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  // transition: .2s ease-in-out;
  // p {
  //   position: relative;
  //   width: 100%;
  //   height: 100%;
  //   i {
  //     position: absolute;
  //     left: 6px;
  //     top: 6px;
  //     transform: rotate(45deg);
  //     color: #ffffff;
  //   }
  // }
  &:active,
  &:focus {
    box-shadow: none;
  }
}
</style>
